import http from "@/lib/http/client"
import { ChatResponse, Message, RenderOption, Thread } from "@/types/api"

export const listThreads = async (): Promise<Thread[]> => {
  const res = await http.get(`/chats/threads`)
  return res.data
}

export const listMessages = async (threadId: string): Promise<Message[]> => {
  const res = await http.get(`/chats/threads/${threadId}/messages`)
  return res.data
}

export const updateThread = async (
  threadId: string,
  data: {
    name: string
  }
): Promise<void> => {
  const res = await http.put(`/chats/threads/${threadId}`, data)
  return res.data
}

export const archiveThread = async (threadId: string): Promise<void> => {
  const res = await http.put(`/chats/threads/${threadId}/archive`)
  return res.data
}

export const deleteThread = async (threadId: string): Promise<void> => {
  const res = await http.delete(`/chats/threads/${threadId}`)
  return res.data
}

export const createMessage = async (data: {
  content: string
  resource_id: string
  thread_id?: string
}): Promise<ChatResponse> => {
  const res = await http.post(`/chats/messages`, data)
  return res.data
}

export const listRenderOptions = async (): Promise<RenderOption[]> => {
  const res = await http.get(`/chats/render-options`)
  return res.data
}
